export default __webpack_public_path__ + "static/media/8070 - Maaria.b466ee33.jpeg";